import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { eventLink } from '../../utils/eventNav';

// Old per-event URLs (/events/:id/edit, /email-log, /health, /analytics) land on the tab and section that now hold the content,
// keeping any query string and an explicit anchor (plan 2142).
export default function LegacyEventRedirect({ tab, anchor }) {
  const { id } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${eventLink(id, tab)}${search}${hash || (anchor ? `#${anchor}` : '')}`} replace />;
}
